declare var moment:any;
declare var $:any;
import { DatePipe } from '@angular/common';
import * as bigdecimal from 'bigdecimal';
import DateTimeUtil from './datatime';

export class Util {
	static validatePassword (str:string):boolean {
		// var re = /((?=.*\d)(?=.*[a-zA-Z])(?=.*[@#$%'"/:;!]).{8,15})/;
    var re = /((?=.*\d)(?=.*[a-zA-Z]).{8,15})/;
    return re.test(str);
	}


  static corpRegFormatter(num:string):string {
    let formatNum:string = '';
    
    if (!num || !num.length) return null;

    if(num.length==11){
      formatNum = num.replace(/(\d{3})(\d{2})(\d{6})/, '$1-$2-$3');
    }else if(num.length==10){
      formatNum = num.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
    }else{
      formatNum = num;
		}
		
    return formatNum;  
  }
  
  
	static phoneFormatter(num:string):string {
		let formatNum:string = '';
    
    if (!num || !num.length) return null;

    if(num.length==11){
      formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }else if(num.length==8){
      formatNum = num.replace(/(\d{4})(\d{4})/, '$1-$2');
    }else{
      if(num.indexOf('02')==0){
        formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
      }else{
        formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      }
		}
		
    return formatNum;
	}


	static currencyFormat(arg:string):string {
    if (isNaN(Number(arg))) return '0';
    var n;
    if(Math.round(Number(arg)) !== Number(arg)) {
      n = Number(arg).toFixed(2);
    } else {
      n = arg;
    }
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}
  
  static currencyFormat2(arg:string):string {
    if (isNaN(Number(arg))) return '0';
    return String(arg).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}


	static dateFomatter(dateStr:string):string {
    var formatDate:string = '';
    if (!dateStr || !dateStr.length) return null;
    if(dateStr.length == 14){
      formatDate = dateStr.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1/$2/$3 $4:$5:$6');
    }else if(dateStr.length == 12) {
      formatDate = dateStr.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1/$2/$3 $4:$5');
    } if(dateStr.length == 8) {
        formatDate = dateStr.replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3');
    } else if(dateStr.length==4){
        formatDate = dateStr.replace(/(\d{2})(\d{2})/, '$1/$2');
    }

    return formatDate;
  }
  
  static dateFomatter2(dateStr:string):string {
    var formatDate:string = '';
    if (!dateStr || !dateStr.length) return null;
    if(dateStr.length == 8) {
        formatDate = dateStr.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3').substr(2);
    } else if(dateStr.length==4){
        formatDate = dateStr.replace(/(\d{2})(\d{2})/, '$1.$2');
    }

    return formatDate;
	}


	static timeFomatter(timeStr:string):string {
    var formatTime = timeStr;
    if (!timeStr || !timeStr.length) return null;
    if(timeStr.length == 4) {
        formatTime = timeStr.replace(/(\d{2})(\d{2})/, '$1:$2');
    }
    return formatTime;
	}

	static numberFormat(x:number):string {
    if (x == null || x == undefined) return "";
    
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  
  static parseDate(str:string):Date {
		if (!str) return null;
		str = str.replace(/[^\d]/g, '');
		if (str.length < 6 ) return null;
		else if (str.length == 6) return moment(str, 'YYYYMM').toDate();
		else if (str.length == 8) return moment(str, 'YYYYMMDD').toDate();
		else if (str.length == 10) return moment(str, 'YYYYMMDDHH').toDate();
    else if (str.length == 12) return moment(str.substr(0, 12), 'YYYYMMDDHHmm').toDate();
    else if (str.length >= 14) return moment(str.substr(0, 14), 'YYYYMMDDHHmmss').toDate();
		else return null;
	}

  static strDateToStrUTCDate(strDate:string){
    let date = this.parseDate(strDate);
    date.setMonth(date.getMonth()+1);
    let resultValue = "";
    resultValue += date.getUTCFullYear();
    if(String(date.getUTCMonth()).length < 2){
        resultValue += "0";
        resultValue += date.getUTCMonth();
    }else{
        resultValue += date.getUTCMonth();
    }
    if(String(date.getUTCDate()).length < 2){
        resultValue += "0";
        resultValue += date.getUTCDate();
    }else{
        resultValue += date.getUTCDate();
    }
    if(String(date.getUTCHours()).length < 2){
        resultValue += "0";
        resultValue += date.getUTCHours();
    }else{
        resultValue += date.getUTCHours();
    }
    if(String(date.getUTCMinutes()).length < 2){
        resultValue += "0";
        resultValue += date.getUTCMinutes();
    }else{
        resultValue += date.getUTCMinutes();
    }
    if(String(date.getUTCSeconds()).length < 2){
        resultValue += "0";
        resultValue += date.getUTCSeconds();
    }else{
        resultValue += date.getUTCSeconds();
    }
    return resultValue;

  }	

  static numberWithCommas(x) {
    if(x == undefined || x == null) return x;
    if(x) return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    else return x;
  }

  static createRange(number){
    var items: number[] = [];
    for(var i = 1; i <= number; i++){
       items.push(i);
    }
    return items;
  }
  static isExistBetweenDate(startDt:string, endDt:string){
    let isExist = false
    

    let formatStartDt:Date = new Date(this.dateFomatter(startDt));
    let formatEndDt:Date = new Date(this.dateFomatter(endDt));
    let todayDt:Date = new Date(this.dateFomatter(moment(new Date()).format('YYYYMMDD')));
    
    if(todayDt >= formatStartDt && todayDt <= formatEndDt) return true;

    return isExist;
  }

  static isExistBetweenDate2(startDt:string, endDt:string, targetDt:string){
    let isExist = false
    

    let formatStartDt:Date = new Date(this.dateFomatter(startDt));
    let formatEndDt:Date = new Date(this.dateFomatter(endDt));
    let todayDt:Date = new Date(this.dateFomatter(targetDt));
    
    if(todayDt >= formatStartDt && todayDt <= formatEndDt) return true;

    return isExist;
  }

  static getString(obj:Object):string {
    let valuesStr:string = '';
    
    for (let propertyName in obj) {
        let itemValue = obj[propertyName];
        if (itemValue instanceof String) itemValue = itemValue.toLocaleLowerCase();
        else if (itemValue instanceof Object) itemValue = this.getString(obj[propertyName]).toLocaleLowerCase();
        else itemValue = String(itemValue).toLocaleLowerCase();

        
        if(propertyName == 'firstNm') valuesStr += itemValue;
        else valuesStr += '|' + itemValue;
    }

    valuesStr = valuesStr.replace(/\s/gi, "");

    return valuesStr;
  }

  static alertWarn(message: string, onClose?:()=>void): void {
    $.sweetModal({
      content: message,
      icon: $.sweetModal.ICON_WARNING,
      onClose: onClose
    });
  }

  static alert(message): void {
    $.sweetModal(message);
  }

  static alertSuccess(message: string, buttons?: any[]): void {
    $.sweetModal({
      content: message,
      icon: $.sweetModal.ICON_SUCCESS,
      buttons: buttons
    });
  }

  static confirm(message: string, ok: ()=>void, cancel: ()=>void) {

    $.sweetModal.confirm(
      message,
      ok,
      cancel 
    );
  }

  static getEndCount(second) {
    var seconds = parseInt(second, 10);

    var days = Math.floor(seconds / (3600*24));
    seconds  -= days*3600*24;
    var hrs   = Math.floor(seconds / 3600);
    seconds  -= hrs*3600;
    var mnts = Math.floor(seconds / 60);
    seconds  -= mnts*60;
    var scnd = seconds; 
    
    return days+"일 "+hrs+"시간 "+mnts+"분 "+scnd+"초"; 
  } 

  static getPortLabel(cntryNmKr: string, portNmKr: string, portCd: string): string{
    let label: string = "";
    if (!cntryNmKr || !portNmKr || !portCd) return label;
    label = portNmKr + "(" + portCd + ") / " + cntryNmKr;
    return label;
  }

  static todayFormatDate() {
    let d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('');
  }

  static getLocalDtmStr(dtm:string):string {
    if(!dtm){
      return;
    }
    let dtmStr = dtm.replace(/[^\d]/gi, '').trim();
    dtmStr = dtmStr.replace(/:/gi, '').trim();
    if (!dtmStr || dtmStr.length <= 0) return null;

    let format = null;
    let outFormat = null;

    if (dtmStr.length == 8) {
      format = 'YYYYMMDD';
      outFormat = 'YYYY/MM/DD';
    } else if (dtmStr.length == 10) {
      format = 'YYYYMMDDHH';
      outFormat = 'YYYY/MM/DD HH';
    } else if (dtmStr.length == 12) {
      format = 'YYYYMMDDHHmm';
      outFormat = 'YYYY/MM/DD HH:mm';
    } else if (dtmStr.length == 14) {
      format = 'YYYYMMDDHHmmss';
      outFormat = 'YYYY/MM/DD HH:mm:ss';
    }
    
    if (!format) return null;
    

		return moment(dtmStr, format).add(9, 'hour').format(outFormat);
  }

  static getDtmLocalStr(dtm: Date): string {
    if (dtm) {
        return moment(dtm).format(DateTimeUtil.dateTimeFormat);
        } else {
        return null;
        }
  }


  static calcLclTotal(cargoList, callback: (lclTotal: LclTotal) => void) {
		let lclCnt = 0;
		let lclTotalCbm = new bigdecimal.BigDecimal("0");
    let lclTotalWeight = new bigdecimal.BigDecimal("0");
    let lclTotalGW = new bigdecimal.BigDecimal("0");
    let lclTotalCW = new bigdecimal.BigDecimal("0");
    let lclTotalRTCbm = new bigdecimal.BigDecimal("0");
    let round = bigdecimal.RoundingMode.UP();

		for (let i = 0 ; i < cargoList.length ; i++) {
			let cargo = cargoList[i];
      if (cargo.count) lclCnt = lclCnt + Number(cargo.count);

			if (cargo.count && cargo.height && cargo.width && cargo.length) {
				let height = new bigdecimal.BigDecimal(cargo.height);
				let length = new bigdecimal.BigDecimal(cargo.length);
        let width = new bigdecimal.BigDecimal(cargo.width);
        
				if (cargo.volUnit === 'cm') {
          height = height.divide(new bigdecimal.BigDecimal('100')).setScale(2, round);
					length = length.divide(new bigdecimal.BigDecimal('100')).setScale(2, round);
          width = width.divide(new bigdecimal.BigDecimal('100')).setScale(2, round);
				} else if (cargo.volUnit === 'inch') {
					height = height.multiply(new bigdecimal.BigDecimal('0.0254')).setScale(2, round);
					length = length.multiply(new bigdecimal.BigDecimal('0.0254')).setScale(2, round);
          width = width.multiply(new bigdecimal.BigDecimal('0.0254')).setScale(2, round);
				} else if(cargo.volUnit === 'mm') {
          height = height.divide(new bigdecimal.BigDecimal('1000')).setScale(2, round);
					length = length.divide(new bigdecimal.BigDecimal('1000')).setScale(2, round);
          width = width.divide(new bigdecimal.BigDecimal('1000')).setScale(2, round);
        }

				let cbm = height.multiply(length.multiply(width));
        lclTotalCbm = lclTotalCbm.add(cbm.multiply(new bigdecimal.BigDecimal(cargo.count)));
        
        let gw = cbm.multiply(new bigdecimal.BigDecimal(cargo.count));
        lclTotalGW = lclTotalGW.add(gw.divide(new bigdecimal.BigDecimal('0.006'), 25, round));
        lclTotalGW = lclTotalGW.setScale(2, round);
			}

			if (cargo.count && cargo.weight) {
        let weight = new bigdecimal.BigDecimal(cargo.weight);
        if (cargo.wghtUnit === 'lb') {
          weight = weight.multiply(new bigdecimal.BigDecimal('0.453592'));
        }
				lclTotalWeight = lclTotalWeight.add(weight.multiply(new bigdecimal.BigDecimal(cargo.count)));
				lclTotalWeight = lclTotalWeight.setScale(2, round);
      }

      let divideThousand = lclTotalWeight.divide(new bigdecimal.BigDecimal('1000'));
      if(divideThousand.compareTo(lclTotalCbm) > 0) {
        lclTotalRTCbm = divideThousand;
      } else {
        lclTotalRTCbm = new bigdecimal.BigDecimal("0");
      }

      if(lclTotalGW.compareTo(lclTotalWeight) > 0) {
        lclTotalCW = lclTotalGW;
      } else {
        lclTotalCW = new bigdecimal.BigDecimal("0");
      }
    }

    if (lclTotalCbm) {
      lclTotalCbm = lclTotalCbm.setScale(3, round);
    }
    
    let lclTotal = { lclCnt: lclCnt, lclTotalCbm : lclTotalCbm, lclTotalRTCbm : lclTotalRTCbm, lclTotalWeight: lclTotalWeight, lclTotalCW: lclTotalCW };

    callback(lclTotal);    
  }
  
  static getLocaleTime(dtmStr:string, outFormat:string):string {
    var testDateUtc = moment.utc(dtmStr);
    var localDate = testDateUtc.local();
    return localDate.format(outFormat);
  }



  static getJobTpText(jobTp: string) {
		switch(jobTp) {
			case '0': {
				jobTp = '화주';
				break;
			}
			case '1': {
				jobTp = '포워더';
				break;
			}
			case '2': {
				jobTp = '선사';
				break;
			}
			case '3': {
				jobTp = '관세사';
				break;
			}
			case '4': {
				jobTp = '운송사';
				break;
			}
			case '5': {
				jobTp = '특송';
				break;
			}
			case '6': {
				jobTp = '하역사(터미널)';
				break;
			}
			case '7': {
				jobTp = '창고(CFS)';
				break;
			}
			case '8': {
				jobTp = '물류IT';
				break;
			}
			case '9': {
				jobTp = '기관협회';
				break;
			}
			case '11': {
				jobTp = '포장';
				break;
			}
			case '12': {
				jobTp = '장비';
				break;
			}
      case '13': {
				jobTp = '무역컨설팅';
				break;
			}
      case '14': {
				jobTp = '항공사';
				break;
			}
			case '10': {
				jobTp = '기타';
				break;
			}
		}
		
		return jobTp;
  }

  static setCookie(name:string ,value: string, days: number, domain?: string): void {
    let expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/" + (domain ? "; domain=" + domain : "");
  }
}


export class LclTotal {
  lclCnt: bigdecimal.BigDecimal;
  lclTotalCbm: bigdecimal.BigDecimal;
  lclTotalRTCbm: bigdecimal.BigDecimal;
  lclTotalWeight: bigdecimal.BigDecimal;
  lclTotalCW: bigdecimal.BigDecimal;
}



// WEBPACK FOOTER //
// ./src/app/utils/util.ts